module.exports = __webpack_public_path__ + "media/images/freee_logo_corporate-92cad57959721c9f90046b8ad6e2cf06.png";